<template>
<div style="display:flex;  justify-content:center; align-items:center;">
  <div  style="width:80%; ">
    <v-card style="height:220px;">
      <v-layout row wrap class="mt-0" >
        <v-flex sm3 xs12>
          <v-card-title primary-title>
          <div>
            <h3 class="mb-0">Descripción:</h3>
            <div>{{item.report.description}}</div>
          </div>
        </v-card-title>
        </v-flex>
        <template v-if="$vuetify.breakpoint.smAndUp"
          ><v-divider vertical></v-divider
        ></template>
        <template v-else
          ><v-flex ma-1 pa-0><v-divider></v-divider></v-flex
        ></template>
        <template>
          <v-flex sm2 mr-0 xs12>
           <v-card-title primary-title>
          <div>
            <h3 class="mb-0">Tipo:</h3>
            <div>{{item.report.typeReport.description}}</div>
          </div>
        </v-card-title>
          </v-flex>
          <template v-if="$vuetify.breakpoint.smAndUp"
            ><v-divider vertical></v-divider
          ></template>
          <template v-else
            ><v-flex ma-1 pa-0><v-divider></v-divider></v-flex
          ></template>
        </template>
        <v-flex sm1 mr-5 xs12>
          <v-card-title primary-title>
          <div>
            <h3 class="mb-0">Creación:</h3>
            <div>{{ item.createdAt.slice(0,-5) }}</div>
          </div>
        </v-card-title>
        </v-flex>

        <template v-if="$vuetify.breakpoint.smAndUp"
          ><v-divider vertical></v-divider
        ></template>
        <template v-else
          ><v-flex ma-1 pa-0><v-divider></v-divider></v-flex
        ></template>
        <template v-if="isTypeGeneral === 1">
          <v-flex sm2 xs12>
            <v-card-title primary-title>
          <div>
            <h3 class="mb-0">Club:</h3>
            <div>{{item.club.nombre}}</div>
          </div>
        </v-card-title>
          </v-flex>
           <v-flex sm3 xs12 mt-2>
          <img :src="item.club.logo" height="100" class="pointer">
        </v-flex>
        </template>
        <template v-if="isTypeGeneral === 2">
        <v-flex sm2 mr-4 xs12>
             <v-card-title primary-title>
          <div>
            <h3 class="mb-0" style="white-space: nowrap;">Fecha y Torneo:</h3>
            <div style="white-space: nowrap;">{{ item.partido.fecha.description }}</div>
          </div>
        </v-card-title>
          </v-flex>
           <template v-if="$vuetify.breakpoint.smAndUp"
          ><v-divider vertical></v-divider
        ></template>
        <template v-else
          ><v-flex ma-1 pa-0><v-divider></v-divider></v-flex
        ></template>
        <v-flex sm1 xs12>
             <v-card-title primary-title>
          <div>
            <h3 style="white-space: nowrap;" class="mb-0">Día y Horario:</h3>
            <div style="white-space: nowrap;">{{ item.partido.dateRealization }}</div>
          </div>
        </v-card-title>
          </v-flex>

        </template>

      </v-layout>
      <v-divider></v-divider>
      <v-layout v-if="isTypeGeneral === 2" row wrap class="mr-0 mx-2 mb-0" style="display:flex; align-items: center; justify-content:center; gap:0px;">
        <div v-if="canEdit || hadPenalties" class="penaltiesContainer">
          <span style="font-size: 20px;">(</span>
          <v-text-field
            min="0"
            class="inputPenalty"
            type="number"
            v-model="localPenaltyGoals"
            style="font-size: 25px;"
            @input="onInputLocalPenaltyChange"
            :readonly="!canEdit"
            ></v-text-field>
        <span style="font-size: 20px;">)</span>
        </div>
        <v-flex sm1 xs12>
      <v-text-field
            type="number"
            v-model="localGoals"
            style="font-size: 35px;"
            @input="onInputLocalChange"
            :readonly="!canEdit"
            ></v-text-field>
      </v-flex>
      <v-flex sm1 xs12>
          <img :src="item.partido.clubLocal.logo" height="50" class="pointer">
        </v-flex>
       <v-flex sm2 xs12 style="max-width: 25%; padding-left:0 ; padding-right: 0; padding-top: 0;">
          <v-card-title primary-title>
            <span  class="titleNombreClub">{{item.partido.clubLocal.nombre}}</span>
          </v-card-title>
        </v-flex>
        <v-flex sm1 xs12>
          <v-card-title primary-title>
            <span style="white-space: nowrap;" class="titleDescripcionGeneral">-</span>
          </v-card-title>
        </v-flex>
         <v-flex sm3 xs12 style="max-width: 25%; padding-left:0 ; padding-right: 0; padding-top: 0;">
          <v-card-title primary-title>
            <span  class="titleNombreClub">{{item.partido.clubVisitor.nombre}}</span>
          </v-card-title>
        </v-flex>
        <v-flex sm1 xs12>
          <img :src="item.partido.clubVisitor.logo" height="50" class="pointer">
        </v-flex>
        <v-flex sm1 xs12 >
        <v-text-field
            type="number"
            v-model="visitorGoals"
            style="font-size: 35px;"
            @input="onInputVisitorChange"
            :readonly="!canEdit"
            ></v-text-field>
      </v-flex>
      <div v-if="canEdit || hadPenalties " class="penaltiesContainer">
        <span style="font-size: 20px;">(</span>
      <v-text-field
            min="0"
            class="inputPenalty"
            type="number"
            v-model="visitorPenaltyGoals"
            style="font-size: 25px;"
            @input="onInputVisitorPenaltyChange"
            :readonly="!canEdit"
            ></v-text-field>
        <span style="font-size: 20px;">)</span>
      </div>
      </v-layout>

    </v-card>

  </div>
  <div style="width:20%;" >
  <v-card class="mb-0 pl-4" style="height:220px; margin-bottom:0px;">
          <InformeAuditoriaTimeline
            :status="getStatus"
          ></InformeAuditoriaTimeline>
           </v-card>
        </div>
        </div>
</template>

<script>
import InformeAuditoriaTimeline from '../components/fields_components/InformeAuditoriaTimeline.vue'
import Constants from '../../../common/constants'

export default {
  props: {
    item: Object
  },
  data () {
    return {
      localGoals: null,
      visitorGoals: null,
      status: null,
      localPenaltyGoals: null,
      visitorPenaltyGoals: null
    }
  },

  methods: {
    onInputLocalChange (event) {
      this.item.localGoals = event
      this.$emit('updateGoals', this.item)
    },
    onInputVisitorChange (event) {
      this.item.visitorGoals = event
      this.$emit('updateGoals', this.item)
    },
    onInputLocalPenaltyChange (event) {
      this.item.localPenaltyGoals = event === '' ? null : event
      this.$emit('updateGoals', this.item)
    },
    onInputVisitorPenaltyChange (event) {
      this.item.visitorPenaltyGoals = event === '' ? null : event
      this.$emit('updateGoals', this.item)
    }
  },
  computed: {
    getStatus () {
      return this.item.status
    },
    isTypeGeneral () {
      return this.item.report.modulo.id
    },
    canEdit () {
      return (
        (this.item.status === Constants.INFORME_STATUS_EN_CARGA) ||
        (this.item.status === Constants.INFORME_STATUS_DEVUELTA)
      )
    },
    hadPenalties () {
      return this.localPenaltyGoals !== null || this.visitorPenaltyGoals !== null
    }
  },
  components: {
    InformeAuditoriaTimeline
  },
  created () {
    this.localGoals = this.item.localGoals
    this.visitorGoals = this.item.visitorGoals
    this.localPenaltyGoals = this.item.localPenaltyGoals
    this.visitorPenaltyGoals = this.item.visitorPenaltyGoals
  }
}
</script>
<style>
.titleDescripcionGeneral {
  color: black;
  font-size: 15px;
  font-family: sans-serif;
  font-weight: bold;
}

.subtitleDescripcionGeneral {
  color: black;
  font-size: 18px;
  font-family: sans-serif;
}
.titleNombreClub{
  color: black;
  font-size: 18px;
  font-family: sans-serif;
  font-weight: bold;
}
.penaltiesContainer{
  display: flex;
  align-items: center;
  width: 50px;
}

</style>
